import { VehicleStatus } from '../types';

export const getStatusLabel = (status: VehicleStatus): string => {
  const labels: Record<VehicleStatus, string> = {
    ready: 'Prêt',
    out: 'Sorti',
    returned: 'Rentré',
    under_maintenance: 'En maintenance',
    washing: 'Lavage'
  };
  return labels[status] || status;
};

export const getStatusColor = (status: VehicleStatus): string => {
  const colors: Record<VehicleStatus, string> = {
    ready: '#4CAF50',           // Green
    out: '#FF9800',            // Orange
    returned: '#2196F3',       // Blue
    under_maintenance: '#F44336', // Red
    washing: '#00BCD4'         // Cyan
  };
  return colors[status] || '#757575';
};

export const getStatusIcon = (status: VehicleStatus): string => {
  const icons: Record<VehicleStatus, string> = {
    ready: '✓',
    out: '📤',
    returned: '📥',
    under_maintenance: '🔧',
    washing: '💧'
  };
  return icons[status] || '●';
};

